export const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
